'use client';

import React from 'react';
import cn from 'classnames';
import { usePathname } from '@framework/next/navigation';
import Header from '@framework/ui/Pages/Landing/Legacy/Sections/Header';
import CookiesBanner from '@framework/cookie-consent/CookiesBanner';
import useLoginUrlWithConsent from '@framework/cookie-consent/useLoginUrlWithConsent';
import Footer from './Footer';
import BookDemoButton from '@/dataroom/ui/common/BookDemoButton';
import ScrollBodyBackground from '@framework/ui/Templates/ScrollBodyBackground';
import DataroomTenantContext from '@dataroom/tenant/DataroomTenantContext';
import config from '@/dataroom/app/config/config';
import dataroomUrl from '@/dataroom/infrastructure/dataroomUrl';
import dmPortalUrl from '@dm-portal/url';
import stickyFooterStyles from '@framework/ui/Organisms/StickyFooter/stickyFooter.module.scss';
import headerStyles from '@framework/ui/Pages/Landing/Legacy/Sections/Header/header.module.scss';
import styles from './tenant17g5Styles.module.scss';
import logo from '../../../assets/17g5LogoText.svg';

interface IProps {
  children: React.ReactNode,
}

const headerMenu = [
  {
    key: 'overview',
    title: 'The Rule',
    path: '/overview',
  },
  {
    key: 'pricing',
    title: 'Pricing',
    path: '/pricing',
  },
];

const Tenant17g5 = ({ children }: IProps) => {
  const tenant = config.tenant.tenant17g5.code;
  const pathname = usePathname();

  const loginUrl = useLoginUrlWithConsent(() =>
    dataroomUrl(tenant).getLoginUrl(dmPortalUrl.getUrl(`/${ tenant }`)),
  );

  const registerUrl = dataroomUrl(tenant).getRegisterUrl(
    dataroomUrl(tenant).getUrl(pathname),
  );

  return (
    <DataroomTenantContext tenant={ tenant }>
      <Header
        tenant={ tenant }
        logo={ logo.src }
        menu={ headerMenu }
        button={ () => (
          <BookDemoButton legacy className={ headerStyles.menuBtn } />
        ) }
        loginUrl={ loginUrl }
        registerUrl={ registerUrl }
      />
      <div className={ cn(styles.pageContainer, stickyFooterStyles.pageContainerWithStickyFooter) }>
        <ScrollBodyBackground tenant={ config.tenant.tenant17g5.code } />
        { children }
      </div>
      <Footer tenant={ tenant } />
      <CookiesBanner />
    </DataroomTenantContext>
  );
};

export default Tenant17g5;
